/*==========================================================
TOUCH DEVICE DETECTION SCRIPT
==========================================================*/

// Detect TouchScreen - can only test after user touches the screen
window.addEventListener('touchstart', function onFirstTouch() {
    $('html').addClass('touch-screen');

    // stop listening after detected
    window.removeEventListener('touchstart', onFirstTouch, false);
}, false);